import r from"./_nativeCreate.js";var a=r,t=Object.prototype.hasOwnProperty;var e=function(r){var e=this.__data__;if(a){var _=e[r];return"__lodash_hash_undefined__"===_?void 0:_}return t.call(e,r)?e[r]:void 0};export{e as default};
//# sourceMappingURL=_hashGet.js.map
